import UpdatePasswordForm from 'components/forms/UpdatePasswordForm';
import AuthCardLayout from 'layouts/AuthCardLayout';
import AuthService from 'services/auth.service';

const ResetPassword = () => {
  const currentUser = AuthService.getCurrentUser();
  return (
    <AuthCardLayout>
      <UpdatePasswordForm id={currentUser.id} />
    </AuthCardLayout>
  );
};

export default ResetPassword;
